import clsx from "clsx";
import styles from "./Navbar.module.css";
import { useNavigate } from "react-router-dom";
import { images } from "../../assets/images";
import { Link } from "react-router-dom";
import { useState } from "react";
import { Backdrop, Divider } from "@mui/material";
import AppInit from "../AppInit/AppInit";
import CountrySelector from "../CountrySelector/CountrySelector";

type Props = {
  isHome: boolean;
};

const HomeNavbar = ({ isHome }: Props) => {
  const navigate = useNavigate();

  const handleJobseeker = () => {
    navigate("/jobseeker");
  };

  const handleLogin = () => {
    if (!localStorage.getItem("userId")) {
      navigate("/login");
      // navigate("/");
      return;
    } else {
      navigate("/dashboard");
    }
  };

  const handleRegister = () => {
    navigate("/signup");
  };

  const [openMenu, setOpenMenu] = useState(false);

  return (
    <>
      <Backdrop open={openMenu}></Backdrop>
      <AppInit />
      <div className={styles.container}>
        <div className={styles.navbarContent}>
          <div className={styles.logoWrapper}>
            <Link to={"/"}>
              <img
                src={images.tascBrandLogo}
                className={styles.brandLogo}
              />
            </Link>
            <div className={styles.pageHolder}>
              {isHome ? "For Employers" : "For Jobseekers"}
            </div>
          </div>
          <div className={styles.rightElems}>
            <p
              onClick={handleJobseeker}
              className={clsx(styles.blue, styles.bold, styles.pointer)}
            >
              Jobseeker?
            </p>
            <div onClick={handleLogin} className={styles.outlineBtn}>
              Log in
            </div>
            <div onClick={handleRegister} className={styles.gradientBtn}>
              Post a Job{" "}
              <img src={images.btnArrow} />
            </div>
            <div className={styles.verticalSeparator}></div>
            <CountrySelector />
          </div>
          <div
            onClick={() => setOpenMenu(!openMenu)}
            className={styles.hamburger}
          >
            <img src={images.menuNew} />
          </div>
        </div>
        {openMenu && (
          <div className={styles.mobileMenu}>
            <div className={styles.menuContent}>
              <div className={styles.menuHeader}>
                <h2>Menu</h2>
                <img
                  src={images.closeMenu}
                  className={styles.pointer}
                  onClick={() => setOpenMenu(false)}
                />
              </div>
              <Divider />
              <div onClick={handleRegister} className={styles.gradientBtn}>
                Post a Job{" "}
                <img src={images.btnArrow} />
              </div>
              <div
                onClick={handleLogin}
                className={clsx(styles.outlineBtn, styles.textCenter)}
              >
                Log in
              </div>
              <p
                onClick={handleJobseeker}
                className={clsx(
                  styles.blue,
                  styles.bold,
                  styles.pointer,
                  styles.textCenter
                )}
              >
                Jobseeker?
              </p>
              <Divider />
              <div className={styles.mobileSelectorRow}>
                <div className={styles.selectorLabel}>
                  <span className={styles.selectorIcon}>🌐</span>
                  <span>Country</span>
                </div>
                <div className={styles.mobileCountrySelector}>
                  <CountrySelector mobile={true} />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default HomeNavbar;
